export default __webpack_public_path__ + "static/media/Girls_1.5920d718.svg";